export default "__VITE_ASSET__gcl4bhoS__"